define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "styled-components", "../../atoms", "../../themes"], function (_exports, _taggedTemplateLiteralLoose2, _styledComponents, _atoms, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Overlay = _exports.NavigationWrapper = _exports.LogoffButton = _exports.HelpButton = _exports.HeaderStyled = _exports.HeaderSeparator = _exports.HeaderContainer = _exports.HamburguerButton = _exports.CloseButton = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

  var HeaderStyled = _styledComponents.default.header.withConfig({
    displayName: "styles__HeaderStyled",
    componentId: "sc-1mumzbp-0"
  })(["background:", ";display:flex;align-itens:center;padding:19px 0;height:", ";width:100%;z-index:7;", ";"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.newOrange;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.scafolding.headerHeight;
  }, function (_ref3) {
    var fixed = _ref3.fixed;
    return fixed && (0, _styledComponents.css)(["position:fixed;"]);
  });

  _exports.HeaderStyled = HeaderStyled;
  var HeaderContainer = (0, _styledComponents.default)(_atoms.Container).withConfig({
    displayName: "styles__HeaderContainer",
    componentId: "sc-1mumzbp-1"
  })(["align-items:center;justify-content:space-between;"]);
  _exports.HeaderContainer = HeaderContainer;
  var HelpButton = (0, _styledComponents.default)(_atoms.ResetButton).withConfig({
    displayName: "styles__HelpButton",
    componentId: "sc-1mumzbp-2"
  })(["display:none;fill:", ";height:24px;", ""], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.white;
  }, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n    margin: 0 8px 0 16px;\n  "]))));
  _exports.HelpButton = HelpButton;

  var HeaderSeparator = _styledComponents.default.div.withConfig({
    displayName: "styles__HeaderSeparator",
    componentId: "sc-1mumzbp-3"
  })(["display:none;fill:", ";height:24px;", ""], function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.white;
  }, _themes.device.desktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n    border-right: 1px solid ", ";\n    display: block;\n    margin: 0 16px;\n  "])), function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.white;
  }));

  _exports.HeaderSeparator = HeaderSeparator;

  var NavigationWrapper = _styledComponents.default.div.withConfig({
    displayName: "styles__NavigationWrapper",
    componentId: "sc-1mumzbp-4"
  })(["background-color:", ";box-shadow:0 1px 2px 0 rgba(0,0,0,0.3);display:flex;flex-direction:column-reverse;height:100vh;justify-content:flex-end;position:fixed;right:0;top:0;width:84vw;z-index:2;transform:translate3d(84vw,0,0);transition:transform 0.4s ", ";", ";", " ", ""], function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.white;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.easing.ease;
  }, function (_ref9) {
    var active = _ref9.active;
    return active && (0, _styledComponents.css)(["transform:translate3d(0,0,0);"]);
  }, _themes.device.tablet(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 50vw;\n    transform: translate3d(50vw, 0, 0);\n\n    ", ";\n  "])), function (_ref10) {
    var active = _ref10.active;
    return active && (0, _styledComponents.css)(["transform:translate3d(0,0,0);"]);
  }), _themes.device.desktop(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n    background-color: transparent;\n    box-shadow: none;\n    display: flex;\n    flex-direction: row;\n    height: auto;\n    justify-content: flex-start;\n    position: static;\n    width: 100%;\n    transform: translate3d(0, 0, 0);\n  "]))));

  _exports.NavigationWrapper = NavigationWrapper;
  var HamburguerButton = (0, _styledComponents.default)(_atoms.ResetButton).withConfig({
    displayName: "styles__HamburguerButton",
    componentId: "sc-1mumzbp-5"
  })(["fill:", ";margin-right:-6px;opacity:1;pointer-events:auto;visibility:visible;", " box-icon{height:36px;width:36px;}"], function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.white;
  }, _themes.device.desktop(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n    opacity: 0;\n    pointer-events: none;\n    visibility: hidden;\n  "]))));
  _exports.HamburguerButton = HamburguerButton;
  var CloseButton = (0, _styledComponents.default)(HamburguerButton).withConfig({
    displayName: "styles__CloseButton",
    componentId: "sc-1mumzbp-6"
  })(["position:absolute;right:18px;top:18px;z-index:2;"]);
  _exports.CloseButton = CloseButton;

  var Overlay = _styledComponents.default.div.withConfig({
    displayName: "styles__Overlay",
    componentId: "sc-1mumzbp-7"
  })(["opacity:0;pointer-events:none;transition:opacity 0.4s ", ";", ";"], function (_ref12) {
    var theme = _ref12.theme;
    return theme.easing.ease;
  }, function (_ref13) {
    var active = _ref13.active;
    return active && (0, _styledComponents.css)(["background-color:", ";bottom:0;left:0;opacity:0.45;pointer-events:auto;position:fixed;right:0;top:0;z-index:2;"], function (_ref14) {
      var theme = _ref14.theme;
      return theme.colors.lightGray;
    });
  });

  _exports.Overlay = Overlay;

  var LogoffButton = _styledComponents.default.div.withConfig({
    displayName: "styles__LogoffButton",
    componentId: "sc-1mumzbp-8"
  })(["border-top:1px solid ", ";bottom:16px;display:block;left:16px;padding-top:24px;padding-top:24px;position:absolute;text-align:center;width:calc(100% - 32px);a{text-decoration:none;width:100%;}", ""], function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.gray;
  }, _themes.device.desktop(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]))));

  _exports.LogoffButton = LogoffButton;
});